import React, { Fragment } from "react";

const Offline = ({ profile, showChat, viewerCount }) => {
  return (
    <Fragment>
      <div className="user-overlay-offline">
        <div className="user-overlay-info">
          <div className="avi-container">
            <img
              src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${profile.avatar}`}
              className="streamer-user-avi"
            />
          </div>
          <div className="helper-container">
            <div className="stream-description-alt">
              <p className="stream-username-title">
                <span className="red description-font mr-10">
                  {profile.channelid}
                </span>
                <span className="white mr-5 description-font-alt">
                  {profile.firstname}
                </span>
              </p>
              <div className="viewers">
                <p className="offline-circle"></p>
                <span className="white bold">Offline</span>{" "}
                <span className="white bold mx-5">
                  {viewerCount && viewerCount.length}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div
          className={
            showChat ? "video-stream-live red" : "video-stream-live-chat red"
          }
        >
          Offline
        </div>
      </div>
      <img
        className="full-video-poster"
        src={`https://ime.sfo3.cdn.digitaloceanspaces.com/img/IME_OfflinePoster_Final_LogosRemoved2024.jpg`}
        alt="offline"
        srcSet=""
      />
    </Fragment>
  );
};

export default Offline;
